<!--
 Copyright (c) Qwoach LLC 2025. All rights reserved.
 Unauthorized copying of this file, via any medium is strictly prohibited
 Proprietary and confidential
 Created by Artem Bogush <artem@qwoach.com> on 31/01/2025
-->

<template>
	<QwoachDialogLayout
		:title="dialogTitle"
		:is-loading="isProgressShowing"
		:loading-message="progressText">

		<div>
			<FormNumberRow
				prop="male"
				class="mb-2"
				title="Number of generations back:"
				:label-min-width="labelMinWidth"
				v-model="numberOfGenerations"
				width="100px"
				:range="range"
				placeholder="0"
			/>
		</div>

	</QwoachDialogLayout>
</template>

<script>

import QwoachDialogLayout from "@/core/components/Dialogs/QwoachDialog/QwoachDialogLayout.vue";
import QwoachDialog from "@/core/components/Dialogs/QwoachDialog/QwoachDialog.vue";
import FormNumberRow from "@/core/components/Form/FormNumberRow.vue";

export default {
	name: "GenogramParentsTemplateDialog",
	extends: QwoachDialog,
	components: {FormNumberRow, QwoachDialogLayout},

	data() {
		return {
			numberOfGenerations: 1,
			range: [1, 4],
			labelMinWidth: 130,
			showAll: false,
		}
	},

	methods: {
		async createDataItem() {
			return this.numberOfGenerations
		}
	},

	computed: {
		dialogTitle() {
			return "Add Parents and Grandparent"
		}
	}
}
</script>

<style lang="scss">

</style>
